// Global stylesheets — load order matters: component-library-classic first (acts
// like `insertAt=top` under webpack), then ovid, then components-checkbox-tree.
// Under Vite, plain side-effect imports inject styles via the runtime; their
// order in this file determines DOM stylesheet order.
import '@opengov/component-library-classic/classic/_styles.scss';

import { setupCheckSession } from '@opengov/session-expiration/index';

import './ovid.scss';

import '@opengov/components-checkbox-tree/index.components-checkbox-tree.css';

import { isPspMounted } from './psp/isPspMounted';
import { createStore } from './store';

// setupCheckSession() polls /api/v3/session on user-activity events to detect
// expired sessions and redirect to /auth/users/sign_in. In PSP mode this is
// owned by the PSP shell. Detect PSP via the window stash pspEntry.mount() sets
// (NOT bnp-core's isPspMode(), because we deliberately leave bnp-core in
// standalone mode — URLs stay relative for same-origin local-dev).
if (!isPspMounted()) {
  setupCheckSession();
}

createStore();
